import userSettingsApi from 'services/api/userSettingsApi';

/* Service class used to perform api calls for retrieving employees/tax pros */
class UserSettingsService {

    constructor() {
        this.api = userSettingsApi.create();
    }

    /**
     * Returns a response from the server indicating whether or not this associate is currently assignable to 
     * an RTE ticket. A null result indicates that the server has no record in the user settings table for this associate.
     * @param {any} associateId the id of the associate, as a long
     */
    async getUserSettings(associateId) {
        const response = await this.api.getUserSettings(associateId);
        if (response && response.status === 200) {
            return response.data;
        }
        return null;
    }

    /**
     * Creates/updates a user setting record for this associate, setting the isRteAssignable flag to the
     * indicated value. Returns the created/updated setting object on success.
     * @param {any} associateId
     * @param {any} isRteAssignable
     * @param {any} isVirAssignable
     */
    async saveUserSettings(associateId, isRteAssignable, isVirAssignable) {
        let response;

        try {
            let payload = {
                associateId: associateId,
                isRteAutoAssign: isRteAssignable,
                isVirAutoAssign: isVirAssignable,
            }
            response = await this.api.saveUserSettings(payload)
        } catch (ex) {
            console.log("Error updating user settings: " + ex.message)
            response = null
        } finally {
            return response
        }
    }
}

const userSettingsService = new UserSettingsService();
export default userSettingsService;
